import { useEffect, useState } from "react";
import { Dimension } from "@dimensional-engineering/dimensional-models";
import Link from "next/link";

import styles from "./DimensionComponents.module.css";

import { iconMapper as icons } from "./icons/iconMapper";
import Image from "next/image";

export default function DimensionRectangle(props: Dimension) {
  const iconMapper: any = icons;
  const icon = iconMapper[props.slug];
  const [href, setHref] = useState<string>("");

  useEffect(() => {
    ///3 hrefs are different-personality: primary-traits, personality-II: cognition, communication-style: work-style
    if (props.slug === "personality") {
      setHref("primary-traits");
    } else if (props.slug === "personality-II") {
      setHref("cognition");
    } else if (props.slug === "communication-style") {
      setHref("work-style");
    } else {
      setHref(props.slug);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.slug]);

  return (
    <Link href={`/dimensions/${href}`}>
      <div className={styles.rectangleParent}>
        <Image
          alt="Dimension image"
          src={`/dimensions/backgrounds/${props.slug}.jpg`}
          fill
          className={styles.dimImage}
        />
        <div className={styles.iconDiv}>{icon}</div>
        <h3>{props.title}</h3>
      </div>
    </Link>
  );
}
